(() => {
    const form = document.querySelector('.shopify-product-form');
    const lasercuttingCheckbox = document.querySelector('#questlog-laser-cutting');

    form.addEventListener('submit', () => {
        if (lasercuttingCheckbox.checked) {
            localStorage.setItem('addLaserCuttingProduct', 'true');
        } else {
            localStorage.setItem('addLaserCuttingProduct', 'false');
        }
    });
})();
